import request from './.request-edge.js'

/**
 * 综合条件查询
 * @param {number} pageNum
 * @param {number} pageSize
 */
export function findExperiments(pageNum, pageSize) {
  return request({
    url: `experiment`,
    method: 'get',
    params: {
      pageNum,
      pageSize
    }
  })
}

/**
 * 根据id读取摘要（较长文本）
 * @param {Number} id
 */
export function findExperimentSummaryById(id) {
  return request({
    url: `experiment/${id}?about=summary`,
    method: 'get'
  })
}

/**
 * 读取当前实验基本信息
 */
export function findCurrentExperiment() {
  return request({
    url: 'experiment?of=current',
    method: 'get'
  })
}

/**
 * 保存实验基本信息
 * @param {Object} experiment 实验基本信息
 */
export function saveCurrentExperiment(experiment) {
  return request({
    url: 'experiment',
    method: 'put',
    data: experiment
  })
}

/**
 * 启动实验
 * @param {Number} id 实验id
 * @param {Object} inception 初始控制条件
 */
export function startCurrentExperiment(experiment) {
  return request({
    url: `experiment?op=start`,
    method: 'put',
    data: experiment
  })
}

/**
 * 结束实验
 * @param {Number} id 实验id
 */
export function completeCurrentExperiment() {
  return request({
    url: `experiment?op=complete`,
    method: 'put'
  })
}



// WEBPACK FOOTER //
// ./src/api/experiment.js